<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">
                {{ kpiID ? "KPI Update" : "KPI Add" }}
              </th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="kpiRules">
        <b-form>
          <b-row>
            <b-col cols="6" md="12" sm="12">
              <b-form-group label="KPI Title" label-for="title">
                <validation-provider
                  name="title"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="kpiValue.title"
                    class="form-control"
                    id="title"
                    name="title"
                    rows="3"
                  ></textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Action" label-for="action">
                <validation-provider
                  name="action"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="kpiValue.action_id"
                    label="title"
                    :reduce="(val) => val.id"
                    :options="actions"
                    :clearable="true"
                  ></v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                {{ kpiID ? "Update KPI" : "Add KPI" }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    vSelect,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const KPI_CODE_APP_STORE_MODULE_NAME = "settings";

    if (!store.hasModule(KPI_CODE_APP_STORE_MODULE_NAME)) {
      store.registerModule(KPI_CODE_APP_STORE_MODULE_NAME, settingsStoreModule);
    }

    onUnmounted(() => {
      if (store.hasModule(KPI_CODE_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(KPI_CODE_APP_STORE_MODULE_NAME);
      }
    });
  },

  data() {
    return {
      kpiValue: {
        title: "",
        action_id: "",
      },
      actions: [],
      formShow: false,
      kpiID: null,
    };
  },

  mounted() {
    this.initializeForm();
  },

  methods: {
    async initializeForm() {
      try {
        await this.getActions();

        if (router.currentRoute.params.id) {
          this.formShow = true;
          this.kpiID = parseInt(router.currentRoute.params.id);
          await this.getKpiById();
        }
      } catch (error) {
        this.formShow = false;
        this.handleError("Form not initialized");
      }
    },

    getActions() {
      return store.dispatch("settings/getAllActions").then((res) => {
        this.actions = res.data;
      });
    },

    getKpiById() {
      return store
        .dispatch("settings/getKPIById", { id: this.kpiID })
        .then((res) => {
          this.kpiValue = res.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.formShow = false;
        });
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.kpiRules.validate().then((success) => {
        if (success) {
          const action = this.kpiID ? "settings/updateKPI" : "settings/saveKPI";

          store
            .dispatch(action, this.kpiValue)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Success",
                  text: this.kpiID
                    ? "✔️ KPI Updated Successfully"
                    : "✔️ KPI Created Successfully",
                  icon: "ThumbsUpIcon",
                  variant: "success",
                },
              });

              router.push({ name: "settings-kpis" });
            })
            .catch(() => {
              this.handleError("KPI error occurred while create");
            })
            .finally(() => {
              this.formShow = false;
            });
        } else {
          this.formShow = false;
        }
      });
    },

    handleError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      this.formShow = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
